import React from "react";
import { Images } from "./images";
import Image from "gatsby-image";
import Opengraph from "../../../../assets/images/cases/rowerowa-przygoda/og.png"
import Video from "../../../../assets/videos/rowerowa-przygoda/video.mp4";
import Video2 from "../../../../assets/videos/rowerowa-przygoda/video-2.mp4";
import Video3 from "../../../../assets/videos/rowerowa-przygoda/video-3.mp4";
import Video4 from "../../../../assets/videos/rowerowa-przygoda/video-4.mp4";
import BannerIcon from "../../../../assets/icons/cases/banner-icon.svg";

export const RowerowaData = () => {
  const images = Images();
  return {
    color: "#fff",
    title: "Rowerowa Przygoda",
    seo: "Dostępna strona WWW — czyli zgodność z WCAG 2.1",
    description: "Aplikacja internetowa gotowa na rowerową przygodę",
    slug: "rowerowa-przygoda",
    opengraph: Opengraph,
    hero: {
      title: "",
      color: "#fff",
      video: Video,
    },
    what_we_did: {
      title: "Dostępna strona WWW — czyli zgodność z WCAG 2.1",
      technologies: [
        "Strona WWW",
        "WCAG 2.1",
        "Video",
        "Foto",
      ],
      text:
        "Na zlecenie Urzędu Marszałkowskiego Województwa Podkarpackiego stworzyliśmy stronę internetową spełniającą standardy dostępności WCAG. Celem witryny miało być promowanie województwa — zachęcenie turystów krajowych i zagranicznych do skorzystania z oferty rowerowej regionu. Dla instytucji priorytetem była też dostępność cyfrowa strony WWW.",
      list: [
        "Przygotowaliśmy treści na stronę",
        "Wykonaliśmy autorskie zdjęcia",
        "Nagraliśmy filmy promocyjne",
        "Zaprojektowaliśmy i zakodowaliśmy stronę internetową",
      ],
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    videos: {
      first: Video2,
      second: Video3,
      third: Video4,
    },
    numbers: {
      first: {
        paddingTop: 1,
        paddingBottom: 1,
        items: [
          {
            title: '100',
            description: 'Tras wycieczek rowerowych',
          },
          {
            title: '5',
            description: 'Krain turystycznych województwa',
          },
          {
            title: '500+',
            description: 'Zdjęć z tras',
          },
          {
            title: '5',
            description: <>Spotów wideo z&nbsp;tras</>,
          },
          {
            title: '200',
            description: 'Atrakcji turystycznych',
          }
        ],
      },
      second: {
        paddingTop: 1,
        background: '#000',
        color: '#fff',
        items: [
          {
            title: '1',
            description: 'Responsywana strona internetowa',
          },
          {
            title: '100',
            description: 'Tras rowerowych',
          },
          {
            title: '500+',
            description: 'Zdjęć z tras',
          },
          {
            title: '5',
            description: <>Spotów wideo z&nbsp;tras</>,
          },
          {
            title: '200',
            description: 'Atrakcji turystycznych Podkarpacia',
          }
        ],
      },
    },
    team: [
      {
        name: 'Patryk “Biały” Białas',
        position: 'projekt UX/ UI / dron / video / rower',
      },
      {
        name: 'Michał Masłowski',
        position: 'opracowanie tras / foto / rower',
      },
      {
        name: 'Patrycja Bilska',
        position: 'projekt manager',
      },
      {
        name: 'Jakub Głogowski',
        position: 'foto',
      },
      {
        name: 'Bartek Kargol',
        position: 'projekt UX/UI / rower ',
      },
      {
        name: 'Mariusz Kusiak',
        position: 'grafika / www',
      },
      {
        name: 'Daria Pyziak',
        position: 'grafika / www',
      },
      {
        name: 'Sylwia Buksa',
        position: 'copywriting',
      },
      {
        name: 'Justyna Bąk',
        position: 'copywriting',
      },
      {
        name: 'Rafał Skórka',
        position: 'front developer',
      },
      {
        name: 'Rafał Krawiec',
        position: 'backend developer',
      },
      {
        name: 'Krystian Drozd',
        position: 'web developer',
      },
      {
        name: 'Adrian Bury',
        position: 'web developer',
      },
    ],
    contact_banners: {
      first: {
        icon: BannerIcon,
        title: 'Potrzebujesz strony zgodnej ze standardem WCAG 2.1?',
        text: <>
          Nie masz czasu, żeby przeczytać więcej? Napisz&nbsp;do&nbsp;nas&nbsp;->
          <br/>
          Jeżeli potrzebujesz więcej informacji, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      },
      second: {
        icon: BannerIcon,
        title: 'Spodobała Ci się nasza realizacja strony WWW?',
        text: <>
          Nie masz czasu, żeby przeczytać więcej? Napisz&nbsp;do&nbsp;nas&nbsp;->
          <br/>
          Jeżeli chcesz zobaczyć efekt fina ny, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      },
    },
    headers: {
      first: "",
      second: "",
    },
    text_boxes: {
      first: {
        title: "Cel projektu",
        text: <>
          Naszym zadaniem było <strong>stworzenie strony internetowej</strong>, która zachęci turystów do odwiedzenia Podkarpacia. Witryna miała spójnie i atrakcyjnie prezentować ofertę turystyczną województwa, szczególnie tę skierowaną do rowerzystów. Stworzona strona dla urzędu miała zachęcać do aktywnego spędzania czasu na łonie natury.
          <br/> <br/>
          Strona WWW, dzięki intuicyjnej dla użytkownika nawigacji, miała umożliwiać łatwe wyszukiwanie i planowanie tras rowerowych wraz z atrakcjami.
        </>,
      },
      second: {
        title: <>Etap przygotowania - planowanie trasy</>,
        text: <>
          Prace nad stroną rozpoczęliśmy od opracowania 100 tras rowerowych zlokalizowanych na terenie Podkarpacia. Na potrzeby projektu powstała również lista atrakcji turystycznych oraz materiały promujące podkarpackie Krainy Turystyczne.
          <br/> <br/>
          Dla każdej wycieczki, atrakcji i krainy przygotowaliśmy: <strong>dedykowane treści na stronę www, materiały promocyjne foto i wideo z zaangażowaniem statystów.</strong>
          <br/> <br/>
          Strona miała być skierowana do turystów krajowych i zagranicznych, dlatego opracowane teksty zostały przetłumaczone na język angielski.
        </>,
      },
      third: {
        title: <>Etap realizacji - ruszamy&nbsp;w&nbsp;trasę</>,
        text: <>
          Na potrzeby realizacji nagrań i sesji fotograficznych zatrudnieni zostali statyści – rowerzyści.
          <br/> <br/>
          Podczas gdy biurze copywrigterzy pracowali nad treściami na stronę, w trasę ruszała "ekipa rowerowa" - filmowiec, fotograf, statyści. Do zabrania: kamery, aparaty, dron i oczywiście rowery. A w powietrzu? Złota - i niestety często kapryśna - polska jesień. Nasz największy przyjaciel i wróg ;)
          <br/> <br/>
          Obróbka, planowanie kolejnych wyjazdów, tworzenie nowych materiałów — wszystko działo się równocześnie. Straciliśmy rachubę. Czas stanął w miejscu, a równocześnie ubiegał nieubłaganie...
        </>
      },
      fourth: {
        title: 'Tworzenie strony WWW',
        text: <>
          Strona internetowa <strong>zgodna z założeniami user experience</strong> to taka, z której korzysta się z przyjemnością. W realizowanym dla urzędu projekcie kluczową rolę odegrał spójny projekt graficzny strony WWW.
          <br/> <br/>
          Zaprojektowane elementy interfejsu strony powstały w oparciu o księgę znaku województwa podkarpackiego oraz identyfikację graficzną krain turystycznych. Pozwoliło to na zachowanie spójności komunikacji oraz nawiązanie do innych witryn instytucji — Urzędu Marszałkowskiego Województwa Podkarpackiego.
          <br/> <br/>
          Strona internetowa to jedna z wizytówek województwa. Zadbaliśmy o to, by była czytelna i intuicyjna, a równocześnie nowoczesna — zgodna z panującymi trendami.
        </>
      },
      fifth: {
        title: <>Responsywna strona internetowa zgodna z&nbsp;WCAG 2.1</>,
        text: <>
          Na portalu Rowerowa Przygoda stworzyliśmy intuicyjny moduł wycieczek rowerowych z możliwością przypisywania atrakcji na mapie. Dzięki temu użytkownik jest w stanie łatwo zaplanować trasę, a następnie pobrać ją <strong>w formacie PDF lub GPX do wykorzystania offline.</strong>
          <br/> <br/>
          Stworzona strona WWW została dostosowana do grupy docelowej — posiada dwie wersje językowe: polską i angielską.
          <br/> <br/>
          Jest również <strong> w pełni responsywna</strong>, co oznacza, że <strong>działa w wersji mobile i desktop</strong>. Ponadto witryna jest zgodna z różnymi przeglądarkami internetowymi (takimi jak: Firefox, Chrome, Opera, Microsoft Edge, Safari).
        </>
      },
      sixth: {
        title: 'Strona WWW dostępna dla niepełnosprawnych',
        text: <>
          Przy tworzeniu stron WWW dla urzędów jednym z najczęstszych wymagań jest dostosowanie witryny do wymagań ustawy o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych oraz WCAG 2.1. Spełniliśmy te warunki.
          <br/> <br/>
          Oprócz tego zadbaliśmy o zgodność strony z ogólnymi przepisami prawa w zakresie polityki prywatności, cookies i RODO.
          <br/> <br/>
          Oddana do użytku instytucji strona internetowa może być swobodnie edytowana, a w przyszłości rozbudowywana.
        </>
      },
      seventh: {
        title: 'Zdjęcia',
        text: <>
          Fotografie to ważna część stworzonej strony internetowej. To właśnie one przyciągają wzrok, zachęcają do odwiedzenia tajemniczych zakątków. Witryna posiada ponad 500 autorskich zdjęć. Dzięki obróbce grafika - fotografa, wszystkie zdjęcia na portalu są spójne, zachowane w jednej kolorystyce.
        </>
      },
      eighth: {
        title: 'Backstage',
        text: <>
          W uchwyceniu najpiękniejszych kadrów największym wyzwaniem okazała się pora roku. Niestabilna pogoda często uniemożliwiała fotografom pracę. Krótkie jesienne dni sprawiły, że nawet największe firmowe śpiochy musiały wstawać o świcie.
        </>
      },
      ninth: {
        title: 'Zrealizowane cele  ',
        text: <>
          W ramach projektu Rowerowa Przygoda powstał największy na Podkarpaciu <strong>portal internetowy</strong>, zawierający 100 tras rowerowych wraz z z plikami GPX oraz 200 najciekawszych atrakcji regionu.
          <br/> <br/>
          Serwis wzbogaciliśmy <strong>autorskimi zdjęciami i dedykowanymi treściami</strong>. Portal podkreśla to, co było ważne dla naszego klienta — Urzędu Marszałkowskiego. Strona promuje zdrowy tryb życia, zachęca do eksplorowania województwa, prezentuje bogatą kulturę i historię Podkarpacia.
          <br/> <br/>
          Spełniliśmy <strong>wytyczne WCAG 2.1</strong> dla stron WWW. <strong>Strona internetowa jest dostępna dla osób z niepełnosprawnościami</strong>, np. wzroku, słuchu, ruchu, niepełnosprawnością intelektualną czy zaburzeniami poznawczymi.
          <br/> <br/>
          Zrealizowaliśmy 5 filmów promocyjnych trwających ok. 1 minutę.
          <br/> <br/>
          Wykonaliśmy efektowną wizualnie prezentację 5 Krain Turystycznych Podkarpacia.
        </>
      },
      tenth: {
        title: 'Referencje',
        text: <>
          <strong><i>Usługa została zrealizowana sprawnie, z dużą rzetelnością i w terminie wynikającym z umowy.</i></strong>
          <br/> <br/>

          <i>
            Współpraca układała się pomyślnie i cechowała ją czytelna komunikacja, duża inwencja i dobra organizacja pracy.
          </i>
          <br/> <br/>

          <i>Zakres prac zlecony firmie obejmował rozbudowę strony internetowej na potrzeby promocji turystyki rowerowej województwa podkarpackiego wraz z opracowaniem tekstów i materiałów multimedialnych, tłumaczeniem na język angielski i ich publikację.</i>
          <br/> <br/> <br/>
          <p style={{ textAlign: "right" }}>
            <strong>
              Dyrektor Departamentu Promocji, Turystyki i Współpracy Gospodarczej <br/>
              Wioletta Rejman
            </strong>
          </p>
        </>
      },
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_4.childImageSharp.fluid}
        />
      ),
      fifth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_5.childImageSharp.fluid}
        />
      ),
      sixth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_6.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.full_1.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.full_2.childImageSharp.fluid}
          />
        ),
      },
    }
  };
};
